import { InviteProfessional } from '~/commonComponents/InviteProfessional';
import { RedirectButton } from '../../../../../commonComponents/Table/RedirectButton';
import { TableData } from '../../../../../commonComponents/Table/TableData';
import { UserSubProfession } from '../../../../../enums/UserProfession';
import { getNumberOfCandidates } from '../../../utils';
import { CancelShift } from '../CancelShift';
import { IDashboardJob } from '~/domain/DashboardJobs/dashboardJobsTypes';

interface IProps {
  item: IDashboardJob;
  handleOnClick: (item: IDashboardJob) => void;
}

export const renderRow = ({ item, handleOnClick }: IProps) => {
  const {
    office,
    startTime,
    endTime,
    date,
    subProfession,
    professionName,
    specialty,
    multipleCounters,
  } = item || {};

  return (
    <>
      <TableData text={office.name} />
      <TableData
        text={
          <span>
            <strong>{date}</strong>
            <br />
            {`${startTime} - ${endTime}`}
          </span>
        }
      />
      <TableData
        text={
          <span>
            <strong>{UserSubProfession.getName(subProfession ?? '') ?? professionName}</strong>
            <br />
            {specialty?.split('_')?.[1] || 'General'}
          </span>
        }
      />
      <td>{getNumberOfCandidates(multipleCounters)}</td>
      <td>
        <InviteProfessional shift={item.dashboardJobApi} size="icon" />
      </td>
      <CancelShift item={item} />
      <RedirectButton onClick={() => handleOnClick(item)} />
    </>
  );
};
